import { Box, Divider, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import BrowseImage from '../../CargoBooking/BrowseImage';
import CustomizedDialogs from '../../../common/CustomizedDialogs';
import ImageModal from '../../CargoBooking/ImageModal';

const ShipmentSnapShots = () => {
    const [RecImage, setRecImage] = useState([
        { headerName: 'Shipment 1', imgUrl: '', sendUrl: "" }, { headerName: 'Shipment 2', imgUrl: '', sendUrl: "" }
    ])
    const [openModal, setOpenModal] = useState({
        open: false,
        titleText: "",
        imageId: 0
    })
    const handleImageModal = (titleText, imageId) => {
        setOpenModal({
            open: true,
            titleText: titleText,
            imageId: imageId
        })
    }
    const handleImage = (file, imageId) => {
        const oldData = [...RecImage];
        if (oldData[imageId] && file) {
            oldData[imageId].imgUrl = URL.createObjectURL(file);
        }
        setRecImage(oldData)
        setOpenModal({
            open: false,
            titleText: '',
            imageId: 0
        })
    }
    return (
        <>
            <Box sx={{ paddingX: '16px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                    <Typography sx={{ marginRight: 2, fontWeight: "600", fontSize: '16px', color: '#004F9E', textTransform: 'uppercase' }}>
                        Shipment SNAPSHOTs
                    </Typography>
                    <Divider sx={{ flexGrow: 1, borderColor: "#004F9E", }} />
                </Box>
                <Grid
                    container
                    display={'flex'}
                    columnSpacing={2}
                    sx={{ paddingTop: '16px' }}
                >
                    {RecImage?.map((obj, index) => (
                        <Grid item md={2}>
                            <BrowseImage index={index} image={obj?.imgUrl} headerName={obj?.headerName} handleImageModal={() => {
                                handleImageModal('Shipment Sanpshots', index)
                            }}
                                removeImage={() => {
                                    const oldData = [...RecImage];
                                    if (oldData[index]) {
                                        oldData[index].imgUrl = '';
                                    }
                                    setRecImage(oldData)
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Box>
                    <Typography sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', fontWeight: 700, color: '#004F9E', marginTop: '10px' }}>
                        <CameraAltIcon /> &nbsp;&nbsp; Capture Snapshots
                    </Typography>
                </Box>
            </Box>
            <CustomizedDialogs open={openModal?.open} titleText={openModal?.titleText} mw={"600px"} onClose={() => {
                setOpenModal({
                    open: false,
                    titleText: "",
                    imageId: 0
                })
            }} >
                <ImageModal handleImage={(file) => {
                    handleImage(file, openModal?.imageId)
                }} />
            </CustomizedDialogs>
        </>

    )
}

export default ShipmentSnapShots